import { instance1, instance2,instance3 } from '../axios'; // 确保路径正确

const api = {
  faucet(data) {
    return instance2.post('/chain/faucet', data); // POST 方法
  },
  txsHash(params) {
    return instance1.get(`/cosmos/tx/v1beta1/txs/${params.hash}`); // GET 方法
  },
  getAssetDetail(data) {
    return instance3.post('/visitorSpots_getAssetDetail', {
      body: data
    }, {
      headers: {
        'TTT': '3A06072384025DEF542721EEFBF0684E'
      }
    });
  },

  getAccounts(params) {
    return instance1.get(`/cosmos/auth/v1beta1/accounts/${params}`); 
  },
  getBalances(params) {
    return instance1.get(`/cosmos/bank/v1beta1/balances/${params.address}/by_denom`,{params});
  },
  getTransactions(params) {
    return instance1.get(`/cosmos/tx/v1beta1/txs`,{params});
  }
};

export default {
  install(Vue) {
    Vue.prototype.$api = api;
  }
};
